var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowTop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.46838 19.9111C0.866984 20.4808 0.841325 21.4302 1.41107 22.0316C1.98082 22.633 2.93022 22.6587 3.53162 22.0889L1.46838 19.9111ZM22.9995 3.04053C23.0218 2.2124 22.3687 1.52293 21.5405 1.50055L8.04545 1.13582C7.21733 1.11343 6.52786 1.76662 6.50548 2.59474C6.48309 3.42287 7.13628 4.11234 7.9644 4.13472L19.96 4.45893L19.6358 16.4545C19.6134 17.2827 20.2666 17.9721 21.0947 17.9945C21.9229 18.0169 22.6123 17.3637 22.6347 16.5356L22.9995 3.04053ZM3.53162 22.0889L22.5316 4.08893L20.4684 1.91107L1.46838 19.9111L3.53162 22.0889Z",
    fill: "#282828"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowTop);
export default __webpack_public_path__ + "static/media/arrow-top.3f64cfbe9a2cd86b840e0d3b3fd8a05f.svg";
export { ForwardRef as ReactComponent };